<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("patient") }}</div>
    <div class="grid is-col-min-12">
      <div class="cell" @click="patients">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/706/706215.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("patients") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="appointments">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.freepik.com/256/12526/12526843.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("appointments") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="team">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/4939/4939112.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("team") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="beds">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/387/387612.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("beds") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="consulting_rooms">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdni.iconscout.com/illustration/premium/thumb/doctor-consultation-room-illustration-download-in-svg-png-gif-file-formats--doctors-office-medical-physician-isometric-pack-people-illustrations-4378896.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("consulting rooms") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="medical_services">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/10299/10299433.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("medical services") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { warning_message, get } from "@/utils";

export default {
  name: "PatientIndex",
  components: {},
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    patients() {
      let v = this;
      v.$router.push({
        path: "/patient/patients",
      });
    },
    appointments() {
      let v = this;
      v.$router.push({
        path: "/patient/calendar",
      });
    },
    team() {
      let v = this;
      v.$router.push({
        path: "/patient/team",
      });
    },
    beds() {
      let v = this;
      v.$router.push({
        path: "/patient/beds",
      });
    },
    consulting_rooms() {
      let v = this;
      v.$router.push({
        path: "/patient/consulting_rooms",
      });
    },
    medical_services() {
      let v = this;
      v.$router.push({
        path: "/patient/medical-services",
      });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}
.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}
</style>
